
import { BLogoV } from '@/components/svg'
import i18n from '@/i18n'
import throttle from 'lodash/throttle'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { Popover } from 'ant-design-vue' // Import Ant Design Vue Popover component

interface Translation {
    slug: string;
    name: string;
    title?: string;
    content?: string;
}

interface OfficeItem {
    slug: string;
    title: string;
    content: string;
}

interface SNSItem {
    link: string;
    icon: string;
    title: string;
    qrcode?: string;
}

@Component({
    components: {
        BLogoV,
        'a-popover': Popover, // Register the Popover component
    },
})
export default class Footer extends Vue {
    showMenu: boolean | string = false;
    office: OfficeItem[] = [];
    sns: SNSItem[] = [];

    async mounted() {
        window.addEventListener('resize', this.throttledRem)

        try {
            const response = await this.$axios.get(`/footer`, {
                params: {
                    fields: '*,translations.*',
                    'deep[translations][_filter][languages_code][_eq]': i18n.locale
                }
            })
            const { office, sns } = response.data.data.translations[0]
            this.office = office
            this.sns = sns
        } catch (error) {
            console.error('Error fetching footer data:', error)
            this.$set(this, 'error', 'Failed to fetch footer data')
        }
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.throttledRem)
    }

    private rem() {
        const { clientWidth } = document.documentElement
        document.documentElement.style.fontSize = `${clientWidth / (clientWidth > 768 ? 1680 : 375)}px`
    }

    private throttledRem = throttle(this.rem, 200);
}
